export const FIELD_SECTION_KEY = 'field';

export const UNASSIGNED_SECTION_KEY = 'unassigned';

export const OTHER_FIELD_SECTION_KEY = 'otherField';
